export default __webpack_public_path__ + "static/media/mp4.bbeb378b.svg";